import { reduxType } from "../../interfaces/reducerType"
const defaultState: boolean = false;
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setParallelLoadin":
            return payload
        default:
            return state;
    }
}
export default reducer;